import styled from 'styled-components';

import Button from 'components/ui/Button';

import { colours, common } from 'themes/default';

export const StyledSeatMapWrapper = styled.div`
  position: relative;
`;

export const SwitchContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  grid-column: 8 / 10;

  > div {
    margin: 30px 5px;
  }
`;

export const MoveContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const UpdateSeatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  > button {
    margin-right: 8px;
  }
`;

export const MoveActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
`;

export const MoveButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  > button {
    margin: 8px;
  }
`;

export const MoveCheckboxesContainer = styled.div`
  margin: 16px 0;
  > label:not(:nth-last-child(1)) {
    margin-bottom: 8px;
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  color: red;
`;

export const StyledButton = styled(Button)`
  width: fit-content;
`;

export const StyledTabContainer = styled.div`
  align-items: stretch;
  border-bottom: 5px transparent solid;
  border-bottom-color: ${(props) => (props.selectedIdIsGreenspeedTrain ? common.classes.er.comfort : colours.Core.CoreNavy)};
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  text-align: center;
  width: 100%;
`;

export const StyledTab = styled.button`
  align-items: center;

  background-color: ${(props) =>
    props.selected
      ? props.selectedIdIsGreenspeedTrain
        ? common.classes.er.comfort
        : colours.Core.CoreNavy
      : colours.Greyscale.SilverGrey};

  border: 0;
  border-bottom: none;
  border-radius: 0;
  color: ${(props) => (props.selected ? colours.Greyscale.White : colours.Greyscale.Black)};
  cursor: ${(props) => (props.selected ? 'default' : 'pointer')};
  flex-grow: 1;
  font-weight: ${(props) => (props.selected ? 400 : 600)};
  margin: 0 2px 0 0;
  padding: 16px 8px 8px 8px;
  text-decoration: none;

  &:first-of-type {
    border-top-left-radius: 7px;
  }

  &:last-of-type {
    border-top-right-radius: 7px;
    margin: 0;
  }
`;

export const LegRoute = styled.div``;

export const LegRouteStation = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

export const LegRouteOrigin = styled(LegRouteStation)`
  &::after {
    content: '➞';
    display: inline-block;
    margin: 0 7px;
  }
`;

export const LegRouteDestination = LegRouteStation;

export const LegDate = styled.div`
  font-size: 13px;
  font-weight: 600;
  margin: 5px 0 0 0;
`;

export const LegTime = styled.span`
  font-weight: 400;
`;

export const WarningContainer = styled.div`
  display: flex;
  flex: 1;
  margin-top: 16px;
`;
